export default {
  path: "/debug",
  redirect: "/debug/index",
  meta: {
    icon: "ri:bug-2-fill",
    showLink: true,
    title: "实时调试",
    rank: 50
  },
  children: [
    {
      path: "/debug/index",
      name: "debug",
      component: () => import("@/views/debug/index.vue"),
      meta: {
        title: "实时调试"
      }
    }
  ]
} satisfies RouteConfigsTable;
